<template>
<div class="pageContent" align="center">
<mu-appbar style="height: 0.8rem;color:black;background-color:#FFFFFF;box-shadow: 1px 4px 90' 20%;position: fixed;top: 0%;">
      <!--返回上一层-->
        <mu-icon value="keyboard_arrow_left" color="#363636" style="margin-top: 0.05rem" slot="left" v-on:click="goback()" />
          <div style="text-align:center;font-size:0.3rem;margin-top:0.15rem;font-family:Microsoft YaHei;height:0.8rem">
             <img src="../../../static/Brand/BarndGmeng2/logo.png" style="height:90%;margin-top:0.04rem">
         </div>
        <mu-icon value="keyboard_arrow_left" color="#FFFFFF" style="margin-top: 0.05rem" slot="right" />
     </mu-appbar>
        <!-- 头部 Logo和首页图片 -->
      <div>
          <div style="position: relative;margin-top:1rem">
              <img src="../../../static/Brand/BarndGmeng2/hotelface.png" style="width:100%" />
          </div>
      </div>

   <!--线条-->
    <hr style="border:none; border-top:1px solid #F1F1F1;"></hr>
    <!-- 品牌介绍 -->
    <div>
         <div class="title">品牌简介</div>
         <div style="font-size:0.29rem;margin-left:0.2rem;margin-right:0.2rem;text-align:left;text-align:justify; 
  text-justify:inter-ideograph;">格盟酒店成立于2008年（*2018由格林联盟升级为格盟），通过理想的地点、卓越的酒店服务、个性化的装饰，向旅客提供别具一格的三星品质服务商旅体验，大多数房间价格在150元-400元。酒店通过标准化运营流程、集团自主PMS系统和健康餐饮等，向旅客提供统一的高标准品质服务。
         </div>
    </div>

     <!--线条-->
    <hr style="border:none; border-top:1px solid #F1F1F1;"></hr>
    <!-- 加盟条件 -->
    <div style=" width:90% ; margin:auto ">
         <div class="title">加盟条件</div>
         <div>
              <img src="../../../static/Brand/BarndGmeng2/joinCondition.png" style="width:100%" />
         </div>

    </div>

    <!--线条-->
    <hr style="border:none; border-top:1px solid #F1F1F1;"></hr>
    <!-- 加盟收费标准 -->
    <div style=" width:90% ; margin:auto ">
         <div style="color:#363636;font-size:0.4rem;margin-top: 0.5rem;font-weight:bold;margin-bottom:0.5rem;border-bottom:2px solid #C79A5E;width:2.4rem">加盟收费标准</div>
         <div>
              <img src="../../../static/Brand/BarndGmeng2/join.png" style="width:100%" />
         </div>
         <div style="font-size:0.2rem;text-align:left;" >*达到公司奖励政策标准,可根据政策享受优惠 </div>
    </div>

    <!--线条-->
    <hr style="border:none; border-top:1px solid #F1F1F1;"></hr>
    <!-- 留言部分 -->
    <div style="color:#FFFFFF;margin-bottom:1.5rem;" id="bottomMessage">
          <div class="title">立即留言</div>
          <div style="margin-top: 0.2rem">
               <div style=" height: 0.75rem ; border-radius: 0.06rem;  border: 1px solid #e2e2e2; text-align:left;width:90% ;margin-top: 0.13rem  ">
                   <input v-model="Name" style=" margin-top: 0.13rem;border:0 ; outline:0 ; color:#A6A4A4 ;width: 90% ; margin-left: 0.2rem  " placeholder="姓名*" />
                </div>

                <div style=" height: 0.75rem ; border-radius: 0.06rem;  border: 1px solid #e2e2e2; text-align:left;width:90% ;margin-top: 0.13rem  ">
                   <input v-model="UserPhone" style="margin-top: 0.13rem; border:0 ; outline:0 ; color:#A6A4A4 ;width: 90% ; margin-left: 0.2rem  " placeholder="电话*" />
                </div>
                  
                <div style=" height: 0.75rem ; border-radius: 0.06rem;  border: 1px solid #e2e2e2; text-align:left;width:90% ;margin-top: 0.13rem  ">
                   <input v-model="City" style="margin-top: 0.13rem; border:0 ; outline:0 ; color:#A6A4A4 ;width: 90% ; margin-left: 0.2rem  " placeholder="城市" />
                </div>

                <div style=" height: 0.75rem ; border-radius: 0.06rem;  border: 1px solid #e2e2e2; text-align:left;width:90% ;margin-top: 0.13rem  ">
                   <input v-model="message" style="margin-top: 0.13rem; border:0 ; outline:0 ; color:#A6A4A4 ;width: 90% ; margin-left: 0.2rem  " placeholder="留言" />
                </div>

                <div>
                  <input v-on:click="messagebtn" type="button"   style="letter-spacing:0.1rem;width:90%; height:0.8rem; background-color:#c79a5e; border-radius:4px;border-width:0;font-size:18px;color: #f5f5f5 ;margin-top: 0.13rem  "  value="提交留言" /> 
                </div>
          </div>
          <div class="buttonText" style="font-size:0.28rem;color:#999999;">格林豪泰酒店（中国）有限公司版权所有</div>
          <div class="buttonText" style="font-size:0.1rem;color:#999999;">投资有风险，选择需谨慎</div>
    </div>
    
    <!-- 固定底部 -->
    <div  class="mu-bottom-nav mu-bottom-nav-shift" tabindex="0" style=" position: fixed;bottom: 0%;user-select: none; cursor: pointer; -webkit-appearance: none;-webkit-box-shadow: #000000 1px 4px 6px;
   -moz-box-shadow: #000000 1px 4px 6px;
   box-shadow: #000000 1px 4px 6px;
   background: #FFFFFF;z-index:9999">
        <div style="float:left;font-size:0.3rem;color:#4B4B4B;;margin-right:1rem ">
          <a href='tel:4006-998-998'>  <img src="../../../static/Brand/BarndGmeng2/tel.png" style="width:20%;" /> 
           <div  style="width:80%;float:right;color:#363636" > 电话咨询  </div></a>
        </div>
        <div style="float:right;font-size:0.3rem;color:#4B4B4B ">
            <a href="#bottomMessage"><img src="../../../static/Brand/BarndGmeng2/message.png" style="width:20%" />
             <div  style="width:80%;float:right;color:#363636" >  在线留言   </div></a>
        </div>
    </div>


    
<mu-toast id="alertline" v-if="toast" v-bind:message="hintMsg" @close="hideToast"/>
</div>
</template>


<style lang="less" scoped>
@import "../../assets/theme.less";

.bottomstyle {
    position: fixed;
    top: 20%;
    width: 100%;
    z-index: 1002;
    left: 10%;
    }

.mu-bottom-nav-shift {
      background-color: #FFF;
      .mu-buttom-item-wrapper {
        .bottomIconColor {
          color: @primaryColor;
        }
        .mu-bottom-item-text {
          color: @primaryColor;
        }
      }
    }
.title{
  color:#363636;
  font-size:0.4rem;
  margin-top: 0.5rem;
  font-weight:bold;
  margin-bottom:0.5rem;
  border-bottom:2px solid #C79A5E;
  width:1.6rem; 
}
.buttonText
{
  margin-top: 0.2rem;
  margin-bottom:0.1rem;
  width:100%;
}
</style>


<script>
import api from "../../api";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import loadListTail from "../../components/loadListTail";
import Scroll from "../../utils/loading";
export default {
  data() {
    return {
         UserPhone: '',
         Name: '',
         City: '',
         message:'',
         hintMsg: '',
         validCode:'',
         toast:false,
    };
  },
  activated() {},
  methods: {
    ...mapMutations(["setG_currentOrder"]),
    initData() {},
    refresh() {
      this.refreshing = true;
      setTimeout(() => {
        this.refreshing = false;
        this.initData();
      }, 2000);
    },

    // 后退一页
    goback() {
      javascript: history.go(-1);
    },

    // 弹出层
    showToast () {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 2000)
    },
    hideToast () {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    messagebtn (){
      if(!this.valid()){
        this.showToast()
        return
      }
      var params = new this.URLSearchParam();
      params.append('FranchiseeName', this.Name);
      params.append('Contact', this.UserPhone);
      params.append('HotelAdderssCity', this.City);
      params.append('ConstructionArea', "");
      params.append('LeaveMessage', this.message);
      params.append('ValidCode', '');
      this.$http.post(api.JoinGreenMessage(), params.toParam()).then((res) => {
        console.log(res)
        if(res.Result == true){
          this.hintMsg = '您的留言已经提交！'
        }
        else{
          this.hintMsg = res.Message
        }
        this.showToast()
      });
    },
    valid(){
      this.hintMsg = ''
      if(!this.Name.isLegal() || !this.UserPhone.isLegal() || !this.City.isLegal() ||!this.message.isLegal()){
        this.hintMsg = '请勿使用非法字符！'
      }
      if(this.Name.trim() == ''){
        this.hintMsg = '请填写您的大名！'
      }
      else if(!this.Name.shorterThan(50)){
        this.hintMsg = '名字过长！'
      }
      if(this.UserPhone.trim() == ''){
        this.hintMsg = '请填写您的手机号码！'
      }
      else if(!this.UserPhone.shorterThan(50)){
        this.hintMsg = '联系方式过长！'
      }
      else if(!this.UserPhone.isPhone()){
        this.hintMsg = '请输入正确的手机号码！'
      }
      if(this.City.trim() != '' && !this.City.shorterThan(20)){
        this.hintMsg = '城市名称过长'
      }
      if(this.message.trim() != '' && !this.message.shorterThan(100)){
        this.hintMsg = '请确认留言内容不超过100个字符！'
      }
      if(this.hintMsg == ''){
        return true
      }
      else{
        return false
      }  
    },
  }
};
</script>




// WEBPACK FOOTER //
// GmengDetail.vue?f5cf174a